const getStringWidth = (str) => {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    (str[i].match(/[ -~]/)) ? len += 1 : len += 2;
  }
  return len + 2;
};

const getWsCols = (sheet) => {
  const objectMaxLength = [];
  sheet.rows.map(cols => {
    cols.forEach((col, i) => {
      let len = 0;
      switch (typeof col.v) {
        case 'number': len = 10; break;
        case 'string': len = getStringWidth(col.v); break;
      }
      objectMaxLength[i] = Math.max(objectMaxLength[i] || 0, len);
    });
  });
  const worksheetCols = objectMaxLength.map(width => {
    return { width: width };
  });
  return worksheetCols;
};

const getWsMerges = (sheet) => {
  const merge = [];
  sheet.rows.forEach((cols, rowN) => {
    cols.forEach((col, colN) => {
      if (col.colSpan <= 1 || col.colSpan == null) {
        return;
      }
      const obj = {
        s: {
          c: colN,
          r: rowN,
        },
        e: {
          c: colN + col.colSpan - 1,
          r: rowN,
        },
      };
      merge.push(obj);
    });
  });
  return merge;
};

const writeExcel = (XLSX, sheetList, filename) => {
  const wb = XLSX.utils.book_new();
  sheetList.forEach(sheet => {
    const ws = XLSX.utils.aoa_to_sheet(sheet.rows);
    const worksheetCols = getWsCols(sheet);
    const merges = getWsMerges(sheet);
    ws['!cols'] = worksheetCols;
    ws['!merges'] = merges;
    XLSX.utils.book_append_sheet(wb, ws, sheet.name);
  });
  XLSX.writeFile(wb, filename);
};

const sanitizeFilename = name => name.replace(/[\\/:*?"<>|]/g, '_');

export const tableListToExcel = async (sheetList, filename, separateFiles = false) => {
  const XLSX = await import('xlsx-js-style');
  if (!separateFiles) {
    writeExcel(XLSX, sheetList, filename);
    return;
  }
  const baseFilename = filename.replace(/\.xlsx$/i, '');
  sheetList.forEach(sheet => {
    writeExcel(XLSX, [sheet], `${baseFilename}_${sanitizeFilename(sheet.name)}.xlsx`);
  });
};